<template>
  <div>
    <MainHeader />
    <section
      class="main-content min-h-screen flex flex-col justify-center p-4"
      :style="{ backgroundImage: `url(${bgImage})` }"
    >
      <div class="mx-auto pb-8">
        <div class="w-40">
          <router-link :to="{ name: 'Home' }">
            <img
              src="../assets/logo_esri_blanco.png"
              alt="Conferencia Esri España 2020"
            />
          </router-link>
        </div>
        <!-- <LogoEsriSpain width="320" color="white" /> -->
      </div>
      <slot />
    </section>
    <MainFooter />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import MainHeader from '@/components/MainHeader'
import MainFooter from '@/components/MainFooter'

export default {
  components: { MainHeader, MainFooter },

  computed: {
    ...mapState('home', ['mainContent']),

    bgImage() {
      if (this.mainContent && this.mainContent.bg_image_url) {
        return this.mainContent.bg_image_url
      }

      return '/img/home-background.jpg'
    },
  },

  mounted() {
    this.$store.dispatch('home/fetchHomeContents')
  },
}
</script>

<style scoped>
section.main-content {
  background-size: cover;
  background-position: center;
  background-attachment: fixed;
}
</style>
